export const ro_translations = {
  translation: {
    menu: {
      go_menu: 'Mergi la Meniu',
      select_lang: 'Selectează Limba',
      suggestions_of_the_moment: 'Recomandări ale Momentului',
      wifi: 'Wi-Fi',
      cookie_preferences: 'Setări Cookie',
      feedback_form: 'Formular de Feedback',
      google_rating: 'Lasă-ne un Review pe Google'
    },
    general: {
      yes: "Da",
      no: "Nu",
      waitstaff_confirm_message: "Sunteți sigur că doriți să chemați chelnerul?",
      call_waitstaff: "Cheamă Chelner",
      calling_waitstaff_successful: "Notificarea a fost trimisă.",
      error: "Eroare!",
      basket: "Coș",
      my_basket: "Coșul Meu",
      basket_text: "Puteți comanda produsele din coș.",
      no_product: "Nu există produse în coș.",
      order: "Plasează Comanda",
      clear_basket: "Golește Coșul",
      add_to_cart: "Adaugă în Coș",
      product_detail_sub_title: "Puteți comanda adăugând produse în coș.",
      total: "Total",
      save: "Salvează",
      cancel: "Anulează",
      name: "Nume",
      note: "Notă",
      send: "Trimite",
      required_field: "Câmp Obligatoriu!",
      successfully_added_to_cart: "Produs adăugat cu succes în coș!",
      successfully_submitted: "Trimis cu succes!",
      please_required_fields: "Vă rugăm să completați câmpurile obligatorii!",
      name_field_cannot_empty: "Câmpul Nume nu poate fi gol!",
      determine_the_product_quantity: "Stabiliți Cantitatea Produsului.",
      maximum_number_of_selections: "Număr Maxim de Selectări:",
      minimum_number_of_selections: "Număr Minim de Selectări pentru {{item}}: {{quantity}}",
      ssid: "Nume Wifi",
      password: "Parolă",
      cookie_title: "Politica de Cookie-uri",
      cookie_text: "Vă rugăm să specificați preferințele dvs. privind colectarea cookie-urilor.",
      cookie_info: "Informații",
      cookie_info_text: "Cookie-urile îmbunătățesc experiența dvs. în sistem.",
      accept: "Acceptă",
      reject: "Refuză",
      your_choice_saved: "Preferința a fost salvată!",
      ok: 'OK',
      allow_location_access: 'Permiteți Accesul la Locație',
      you_can_order_if_you_allow_location_access: 'Puteți comanda dacă permiteți accesul la locație!',
      search_all_products: 'Căutați în toate produsele...',
      description: 'Descriere',
      all_items_delete_in_basket: 'Toate produsele din coș vor fi șterse!',
      delete: 'Șterge',
      successful: 'Succes!',
      delete_the_product: 'Veți șterge produsul!',
      order_failed: 'Comanda nu a putut fi plasată!',
      outside_order_border: 'Nu se poate plasa comanda deoarece sunteți în afara zonei de livrare!',
      waitstaff_call_failed: 'Chelnerul nu a putut fi chemat!',
      outside_waitstaff_border: 'Chelnerul nu poate fi chemat deoarece vă aflați în afara zonei!',
      you_can_call_waitstaff_if_you_allow_location_access: 'Puteți chema chelnerul dacă permiteți accesul la locație!',
      order_transmitted: 'Comanda a fost transmisă!',
      enjoy_your_meal: 'Comanda dvs. a fost primită. Poftă Bună!',
      minute: 'Min',
      select: 'Selectare',
      required_selections: "Selectări Obligatorii",
      optional_selections: "Selectări Opționale",
      calorie: "cal",
      sold_out: "Epuizat",
      this_product_sold_out: "Acest produs este epuizat.",
    },
    labels: {
      new: "Nou",
      star: "Aperitiv",
      chefs_suggestion: "Prezentare Specială",
    }
  }
}
